import { useUpdateOrganizationContext } from '../context';
import * as S from './styles';

export function Content() {
	const { steps, currentStep } = useUpdateOrganizationContext();

	return <S.Container span={24}>{steps[currentStep]?.component}</S.Container>;
}
